import axios from 'axios';
import {message} from 'ant-design-vue';

// App 只访问公开展示接口，不再读取或携带商户后台登录信息。
const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 120000
});

const PUBLIC_MCH_ID_KEY = 'ai-video-public-mch-id';

// 首次按码牌解析商户，后续公开请求显式拼接该 mchId。
http.interceptors.request.use(config => {
  const mchId = window.sessionStorage.getItem(PUBLIC_MCH_ID_KEY);
  if (mchId) config.params = {...(config.params || {}), mchId};
  return config;
});

// 将公开接口的业务响应解包，并向访客展示可理解的错误提示。
http.interceptors.response.use(
  response => {
    const body = response.data;
    if (body.code !== 0) {
      const error = new Error(body.message || '页面加载失败');
      error.code = body.code;
      if (!response.config.silent) message.error(error.message);
      return Promise.reject(error);
    }
    if (body.data && body.data.mchId) {
      // 页面聚合或绑定响应返回商户后，缓存给后续评价、视频请求使用。
      window.sessionStorage.setItem(PUBLIC_MCH_ID_KEY, body.data.mchId);
    }
    return body.data;
  },
  error => {
    const errorMessage = error.response && error.response.data && error.response.data.message
      ? error.response.data.message
      : (!error.response ? '无法连接后台服务，请稍后重试' : `请求失败（${error.response.status}）`);
    const requestError = new Error(errorMessage);
    requestError.code = error.response ? error.response.status : 0;
    if (!error.config || !error.config.silent) message.error(errorMessage);
    return Promise.reject(requestError);
  }
);

export default http;
